"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioPlayer = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
var AudioPlayer = exports.AudioPlayer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  background: linear-gradient(\n      180deg,\n      rgba(51, 54, 73, 0) 0%,\n      rgba(0, 149, 255, 0.09) 51.91%,\n      rgba(51, 54, 73, 0) 127.78%\n    ),\n    #1e2130;\n  border-radius: 2px;\n  position: relative;\n  width: 100%;\n  height: inherit;\n\n  audio {\n    position: absolute;\n    bottom: 0;\n  }\n"])));